import axios from "axios";
import setTokenWithExpiration from "../helpers/jwt-token-access/auth-token-header";

export async function createUser(payload) {
  try {
    const response = await axios.post("auth/signup/new-merchant", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in createUser:", error);

    if (error.response) {
      console.error("Error data:", error.response.data);
      console.error("Error status:", error.response.status);

      // Throw the error with a custom message for React Query to catch
      throw new Error(
        error.response.data.details || "Failed to register merchant"
      );
    } else if (error.request) {
      throw new Error(
        "No response received from server. Please check your internet connection."
      );
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
}

export async function signIn(email, password) {
  const response = await axios("/auth/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok)
    throw new Error("Failed on sign in request", response.statusText);

  return await response.json();
}

const TOKEN_EXPIRATION_IN_MINUTES = 60;

export async function login({ phonenumber, password }) {
  try {
    const response = await axios.post("auth/signin", {
      phoneNumber: phonenumber,
      password,
    });

    const { token, user, refreshToken } = response;

    setTokenWithExpiration(token, TOKEN_EXPIRATION_IN_MINUTES);
    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("refreshToken", refreshToken);

    return response.user;
  } catch (e) {
    throw new Error(e.response?.data?.message || e?.message || e?.toString());
  }
}

export function logout() {
  // Remove the session token from local storage
  localStorage.removeItem("accessToken");

  // Optionally, you can also clear the query cache
  // const queryClient = useQueryClient();
  // queryClient.clear();
}
